var React = require('react');

function HeroRound (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M789 99.5C789 317.376 612.376 494 394.5 494S0 317.376 0 99.5 176.624-295 394.5-295 789-118.376 789 99.5","fill":"#FFF","fillRule":"evenodd","opacity":".03"}));
}

HeroRound.defaultProps = {"width":"789","height":"494"};

module.exports = HeroRound;

HeroRound.default = HeroRound;
